import React from "react";

import SectionContent from "../../../../SectionContent/SectionContent";

import "./TabField.scss";

const TabField = ({ myRef, field, index, sectionTitle, ...props }) => {
  const [isValidationError, setIsValidationError] = React.useState(true);

  React.useEffect(() => {
    if (
      field.inputType === "TextField" ||
      field.inputType === "TextArea" ||
      field.inputType === "Date" ||
      field.inputType === "Number" ||
      field.inputType === "Currency"
    ) {
      setIsValidationError(field.fieldLabel.trim() === "");
    } else if (field.inputType === "Checkbox" || field.inputType === "Radio" || field.inputType === "Dropdown") {
      let isError = field.fieldLabel.trim() === "" || field.options?.length === 0;
      if (!isError) {
        const emptyOptions = field.options.findIndex((option) => option.optionValue.trim() === "");
        isError = emptyOptions !== -1;
      }
      setIsValidationError(isError);
    }
  }, [field.fieldLabel, field.inputType, field.options]);

  const addFieldRef = React.useRef([]);

  React.useEffect(() => {
    if (addFieldRef) {
      addFieldRef.current.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }, []);

  const handleSubmit = () => {
    if (field.mode === "Create") {
      props.handleAddField({
        ...field,
        mode: "Created",
      });
    } else {
      props.handleEditField({
        ...field,
        mode: "Created",
      });
    }
  };

  return (
    <div className="tab-field" ref={addFieldRef}>
      <div className="tab-field-title">{sectionTitle}</div>
      <div className="tab-field-content">
        <SectionContent
          sectionItem={field}
          sectionId={field.fieldId}
          index={index}
          updatedField={props.updatedField}
          cancelFieldHandler={props.cancelFieldHandler}
          addOptionHandler={props.addOptionHandler}
          updateOptionValue={props.updateOptionValue}
          deleteOptionsHandler={props.deleteOptionsHandler}
          changeFieldHandler={props.changeFieldHandler}
          errors={[]}
          setIsValidationError={setIsValidationError}
          mode="CustomTemplate"
        />
      </div>
      <div className="tab-field-footer d-flex justify-content-end">
        <button className="btn-secondary mr-2" onClick={() => props.cancelFieldHandler(field)}>
          Cancel
        </button>
        <button className="btn-primary" onClick={handleSubmit} disabled={isValidationError}>
          {field.mode === "Create" ? `Add` : `Save`}
        </button>
      </div>
    </div>
  );
};

export default TabField;
